import { HTTPVerbs } from '@nextgen-web-framework/core';
import type { RequestOptions } from '@nextgen-web-framework/core';

export function getCategorytReqObj(versionId: string, categoryId: string): RequestOptions {
  return {
    url: `/comcategoryas/${versionId}/categories/${categoryId}`,
    method: HTTPVerbs.GET,
    headers: {
      'Content-Type': 'application/json',
    },
    retries: 0,
  };
}

export function getCategoriesReqObj(version: string): RequestOptions {
  return {
    url: `/comcategoryas/${version}/categories`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}

export function getCategoriesByIdsReqObj(version: string): RequestOptions {
  return {
    url: `/comcategoryas/${version}/categories`,
    method: HTTPVerbs.GET,
    retries: 0,
  };
}
